import { isPlatformBrowser } from '@angular/common';
import {
  Injectable,
  signal,
  Signal,
  inject,
  DestroyRef,
  PLATFORM_ID,
} from '@angular/core';

/**
 * Get a signal that emits the current classList
 * whenever it changes on the given element.
 */
@Injectable({ providedIn: 'root' })
export class ClassListChangeService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);

  getClassListSignal(element: HTMLElement): Signal<DOMTokenList> {
    if (!isPlatformBrowser(this.platformId)) {
      // On the server, just return the current classList as a signal
      return signal<DOMTokenList>(element.classList).asReadonly();
    }

    const classList = signal<DOMTokenList>(element.classList);
    const observer = new MutationObserver((mutations: MutationRecord[]) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          classList.set(element.classList);
        }
      }
    });
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class'],
    });
    this.destroyRef.onDestroy(() => observer.disconnect());
    return classList.asReadonly();
  }
}
